import { Link } from 'react-router-dom';
import { HttpStatusCode } from '@sib/api';
import { Button } from '@sib/ui';
import { DocumentNotFound as DocumentNotFoundIcon } from '@sib/ui/icons';
import { paths } from '@spendbrain/config/paths';
import { useAppTranslation } from '../../hooks';

export const DocumentNotFound = () => {
  const { t } = useAppTranslation();

  return (
    <div className="flex size-full flex-col items-center justify-center gap-4">
      <DocumentNotFoundIcon
        className="text-primary mb-5 size-36"
        aria-hidden="true"
      />
      <div className="text-primary flex flex-col items-center justify-center gap-10 text-center text-5xl font-medium">
        <p>{HttpStatusCode.NotFound}</p>
        <p>{t('components.documentPreview.documentNotFound.title')}</p>
      </div>
      <p className="text-muted-foreground mt-5 text-center text-sm">
        {t('components.documentPreview.documentNotFound.description')}
      </p>
      <div className="flex items-center justify-center gap-2">
        <Button asChild className="h-10" variant="outline">
          <Link to={paths.dashboard}>
            {t('errors.redirect', { module: t('errors.modules.dashboard') })}
          </Link>
        </Button>
        <Button asChild className="h-10">
          <Link to={paths.documents.root}>
            {t('errors.redirect', { module: t('errors.modules.documents') })}
          </Link>
        </Button>
      </div>
    </div>
  );
};
